export const GET_USER_REPORTS = "GET_USER_REPORTS"
export const GET_USER_REPORTS_SUCCESS = "GET_USER_REPORTS_SUCCESS"
export const GET_USER_REPORTS_FAILED = "GET_USER_REPORTS_FAILED"

export const GET_ACTIVE_USERS_REPORTS = "GET_ACTIVE_USERS_REPORTS"
export const GET_ACTIVE_USERS_REPORTS_SUCCESS =
  "GET_ACTIVE_USERS_REPORTS_SUCCESS"
export const GET_ACTIVE_USERS_REPORTS_FAILED = "GET_ACTIVE_USERS_REPORTS_FAILED"

export const GET_NEW_USERS_REPORTS = "GET_NEW_USERS_REPORTS"
export const GET_NEW_USERS_REPORTS_SUCCESS = "GET_NEW_USERS_REPORTS_SUCCESS"
export const GET_NEW_USERS_REPORTS_FAILED = "GET_NEW_USERS_REPORTS_FAILED"

export const GET_RECENT_EXPERIENCES = "GET_RECENT_EXPERIENCES"
export const GET_RECENT_EXPERIENCES_SUCCESS = "GET_RECENT_EXPERIENCES_SUCCESS"
export const GET_RECENT_EXPERIENCES_FAILED = "GET_RECENT_EXPERIENCES_FAILED"

export const GET_AD_REPORTS = "GET_AD_REPORTS"
export const GET_AD_REPORTS_SUCCESS = "GET_AD_REPORTS_SUCCESS"
export const GET_AD_REPORTS_FAILED = "GET_AD_REPORTS_FAILED"

export const GET_BOOKING_PAYMENT_REPORTS = "GET_BOOKING_PAYMENT_REPORTS"
export const GET_BOOKING_PAYMENT_REPORTS_SUCCESS =
  "GET_BOOKING_PAYMENT_REPORTS_SUCCESS"
export const GET_BOOKING_PAYMENT_REPORTS_FAILED =
  "GET_BOOKING_PAYMENT_REPORTS_FAILED"

export const GET_DASHBOARD_SECTIONS = "GET_DASHBOARD_SECTIONS"
export const GET_DASHBOARD_SECTIONS_SUCCESS = "GET_DASHBOARD_SECTIONS_SUCCESS"
export const GET_DASHBOARD_SECTIONS_FAILED = "GET_DASHBOARD_SECTIONS_FAILED"

export const UPDATE_DASHBOARD_SECTIONS = "UPDATE_DASHBOARD_SECTIONS"
export const UPDATE_DASHBOARD_SECTIONS_SUCCESS =
  "UPDATE_DASHBOARD_SECTIONS_SUCCESS"
export const UPDATE_DASHBOARD_SECTIONS_FAILED =
  "UPDATE_DASHBOARD_SECTIONS_FAILED"

export const GET_FEATURE_RESPONSES_BY_USER = "GET_FEATURE_RESPONSES_BY_USER"
export const GET_FEATURE_RESPONSES_BY_USER_SUCCESS =
  "GET_FEATURE_RESPONSES_BY_USER_SUCCESS"
export const GET_FEATURE_RESPONSES_BY_USER_FAILED =
  "GET_FEATURE_RESPONSES_BY_USER_FAILED"
export const RESET_FEATURE_RESPONSES_BY_USER = "RESET_FEATURE_RESPONSES_BY_USER"

export const GET_ALL_USER_RESPONSES = "GET_ALL_USER_RESPONSES"
export const GET_ALL_USER_RESPONSES_SUCCESS = "GET_ALL_USER_RESPONSES_SUCCESS"
export const GET_ALL_USER_RESPONSES_FAILED = "GET_ALL_USER_RESPONSES_FAILED"
export const RESET_ALL_USER_RESPONSES = "RESET_ALL_USER_RESPONSES"

export const GET_FEATURE_USAGE_REPORT = "GET_FEATURE_USAGE_REPORT"
export const GET_FEATURE_USAGE_REPORT_SUCCESS =
  "GET_FEATURE_USAGE_REPORT_SUCCESS"
export const GET_FEATURE_USAGE_REPORT_FAILED = "GET_FEATURE_USAGE_REPORT_FAILED"
export const RESET_FEATURE_USAGE_REPORT = "RESET_FEATURE_USAGE_REPORT"

export const GET_APP_OPENS_REPORTS = "GET_APP_OPENS_REPORTS"
export const GET_APP_OPENS_REPORTS_SUCCESS = "GET_APP_OPENS_REPORTS_SUCCESS"
export const GET_APP_OPENS_REPORTS_FAILED = "GET_APP_OPENS_REPORTS_FAILED"
export const RESET_APP_OPENS_REPORTS = "RESET_APP_OPENS_REPORTS"

export const GET_APP_OPENS_MONTH_REPORT = "GET_APP_OPENS_MONTH_REPORT"
export const GET_APP_OPENS_MONTH_REPORT_SUCCESS =
  "GET_APP_OPENS_MONTH_REPORT_SUCCESS"
export const GET_APP_OPENS_MONTH_REPORT_FAILED =
  "GET_APP_OPENS_MONTH_REPORT_FAILED"

export const GET_ACTIVE_SITE_USERS = "GET_ACTIVE_SITE_USERS"
export const GET_ACTIVE_SITE_USERS_SUCCESS = "GET_ACTIVE_SITE_USERS_SUCCESS"
export const GET_ACTIVE_SITE_USERS_FAILED = "GET_ACTIVE_SITE_USERS_FAILED"

export const GET_FORM_BUILDER_PAYMENT_REPORTS =
  "GET_FORM_BUILDER_PAYMENT_REPORTS"
export const GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS =
  "GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS"
export const GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED =
  "GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED"

export const GET_FORM_LIST = "GET_FORM_LIST"
export const GET_FORM_LIST_SUCCESS = "GET_FORM_LIST_SUCCESS"
export const GET_FORM_LIST_FAILED = "GET_FORM_LIST_FAILED"

export const GET_FEATURE_CLICKS = "GET_FEATURE_CLICKS"
export const GET_FEATURE_CLICKS_SUCCESS = "GET_FEATURE_CLICKS_SUCCESS"
export const GET_FEATURE_CLICKS_FAILED = "GET_FEATURE_CLICKS_FAILED"
export const RESET_FEATURE_CLICKS = "RESET_FEATURE_CLICKS"

export const GET_FEATURE_VIEWS_BY_USER = "GET_FEATURE_VIEWS_BY_USER"
export const GET_FEATURE_VIEWS_BY_USER_SUCCESS =
  "GET_FEATURE_VIEWS_BY_USER_SUCCESS"
export const GET_FEATURE_VIEWS_BY_USER_FAILED =
  "GET_FEATURE_VIEWS_BY_USER_FAILED"
export const RESET_FEATURE_VIEWS_BY_USER = "RESET_FEATURE_VIEWS_BY_USER"

export const DISPLAY_DEFAULT_REPORTS = "DISPLAY_DEFAULT_REPORTS"
export const DISPLAY_DEFAULT_REPORTS_SUCCESS = "DISPLAY_DEFAULT_REPORTS_SUCCESS"
export const DISPLAY_DEFAULT_REPORTS_FAILED = "DISPLAY_DEFAULT_REPORTS_FAILED"

export const GET_ALL_FEATURE_REPORTS = "GET_ALL_FEATURE_REPORTS"
export const GET_ALL_FEATURE_REPORTS_SUCCESS = "GET_ALL_FEATURE_REPORTS_SUCCESS"
export const GET_ALL_FEATURE_REPORTS_FAILED = "GET_ALL_FEATURE_REPORTS_FAILED"
